import React from 'react';
import { Accordion, AccordionDetails, AccordionSummary, Box, Container, Typography } from '@mui/material';
import ExpandMoreRoundedIcon from '@mui/icons-material/ExpandMoreRounded';

const questions = [
  {
    question: 'What is a real estate CRM?',
    answer: 'A real estate CRM keeps every property enquiry, call, WhatsApp chat, site visit and booking in one place, so your sales team knows who to follow up and nothing is lost. AcoLead is a real estate CRM built for builders, channel partners, mandate firms and brokers.',
  },
  {
    question: 'Why choose AcoLead as your real estate CRM?',
    answer: 'It is built only for real estate. It connects to property marketplaces and Meta and Google ads, works on WhatsApp the way buyers actually talk, replies in the buyer’s own language through its AI Sales Agent, and covers site visits, channel partners, inventory and post-sales in the same CRM.',
  },
  {
    question: 'Can you migrate our existing leads into AcoLead?',
    answer: 'Yes. Send us an export from your current CRM or Excel and we bring your leads, sources, stages and history into AcoLead, so your team starts with everything in place.',
  },
  {
    question: 'How long does setup take?',
    answer: 'We set up your projects, lead sources, routing rules, WhatsApp and team with you, and train your admins and sales team, so you start working leads in AcoLead quickly.',
  },
  {
    question: 'Which portals and lead sources are supported?',
    answer: '99acres, MagicBricks, Housing.com, Meta Lead Ads, Google Ads, your website, Instagram, Facebook, WhatsApp, YouTube, QR codes, walk-ins and channel partners. Every enquiry arrives automatically with its source and is assigned to the right salesperson. Marketplaces in other regions, such as Bayut, Property Finder and Dubizzle in Dubai, Rightmove and Zoopla in the UK, Idealista and ImmoScout24 in Europe, and Zillow in the US, can be integrated when you need them.',
  },
  {
    question: 'How much does WhatsApp API usage cost?',
    answer: 'Meta charges for WhatsApp template messages at its published rates, and replies within 24 hours of a customer’s message are free. The AcoLead WhatsApp add-on is included in your quote.',
  },
  {
    question: 'Is there a mobile app for my sales team?',
    answer: 'Yes. AcoLead has Android and iOS apps to help your team manage leads, follow-ups, visit schedules and customer communication while in the field.',
  },
  {
    question: 'How does AcoLead protect our customer data?',
    answer: 'AcoLead runs on Amazon Web Services (AWS), with your data in MongoDB Atlas, a managed cloud database. Everything sent between your browser or phone and AcoLead is encrypted in transit with HTTPS (TLS), and your data is encrypted at rest in the database and in file storage. Inside AcoLead, role-based access means each person sees only the leads they should, and every change is recorded in an activity trail.',
  },
];

const faqSchema = { '@context': 'https://schema.org', '@type': 'FAQPage', mainEntity: questions.map(({ question, answer }) => ({ '@type': 'Question', name: question, acceptedAnswer: { '@type': 'Answer', text: answer } })) };

const HomeFaq = () => {
  React.useEffect(() => {
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.id = 'home-faq-schema';
    script.textContent = JSON.stringify(faqSchema);
    document.head.appendChild(script);
    return () => script.remove();
  }, []);
  return (
  <Box component="section" aria-labelledby="home-faq-title" sx={{ py: { xs: 6, md: 8 }, bgcolor: '#F8FBFF' }}>
    <Container maxWidth="md">
      <Box sx={{ textAlign: 'center', mb: { xs: 3, md: 4 } }}>
        <Typography component="h2" id="home-faq-title" sx={{ color: '#101C2E', fontFamily: 'Plus Jakarta Sans, sans-serif', fontWeight: 800, fontSize: { xs: 30, md: 38 }, letterSpacing: '-.035em' }}>
          Frequently Asked <Box component="span" sx={{ color: '#0859C1' }}>Questions</Box>
        </Typography>
        <Box sx={{ width: 48, height: 4, borderRadius: 2, bgcolor: '#3B9D1D', mx: 'auto', mt: 1.7 }} />
      </Box>
      {questions.map(({ question, answer }) => (
        <Accordion key={question} disableGutters elevation={0} sx={{ bgcolor: '#fff', border: '1px solid #E1E9F3', borderRadius: '12px !important', mb: 1, '&:before': { display: 'none' } }}>
          <AccordionSummary expandIcon={<ExpandMoreRoundedIcon sx={{ color: '#0859C1' }} />} sx={{ px: { xs: 1.7, sm: 2.2 }, minHeight: 58 }}>
            <Typography sx={{ color: '#14243A', fontWeight: 700, fontSize: { xs: 13, sm: 14 } }}>{question}</Typography>
          </AccordionSummary>
          <AccordionDetails sx={{ px: { xs: 1.7, sm: 2.2 }, pt: 0 }}>
            <Typography sx={{ color: '#596A80', fontSize: 13, lineHeight: 1.7 }}>{answer}</Typography>
          </AccordionDetails>
        </Accordion>
      ))}
    </Container>
  </Box>
  );
};

export default HomeFaq;
